// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"775":"gsap","9508":"ScrollTrigger"}[chunkId] + "." + {"775":"6f132980fcbc6d034748","9508":"ba3749b094d451c3b639"}[chunkId] + ".js";
};